import React, { useEffect, useRef, useState } from 'react';

import { ReactComponent as SearchIcon } from 'icons/icon-search.svg';
import { ReactComponent as MicrophoneIcon } from 'icons/icon-microphone.svg';
import { ReactComponent as InactiveMicrophoneIcon } from 'icons/inactive-microphone-icon.svg';
import { ReactComponent as ActiveMicrophoneIcon } from 'icons/active-microphone-icon.svg';

import Modal from 'components/utility/Modal/Modal';
import P from 'components/elements/p';
import Box from 'components/elements/Box';
import {
  Form,
  MicrophoneIconWrapper,
  SearchIconWrapper,
  Input,
  AnimatedRing,
  IconWrapper,
} from './SearchDropdown.styles';

interface ISearchInput {
  handleSubmit: (event: any) => void;
  handleChange: (event: any) => void;
  handleOnFocus: () => void;
  searchValue: string;
  active: boolean;
  placeholderValue?: string;
  getSpeechSearchValue: (speechStr: string) => void;
}
const SearchInput: React.FC<ISearchInput> = (props) => {
  const {
    handleSubmit,
    handleChange,
    handleOnFocus,
    active,
    searchValue,
    placeholderValue = 'Search Opus',
    getSpeechSearchValue,
  } = props;

  const speech: any = useRef(null);
  const [isSpeechSupported, setIsSpeechSupported] = useState<boolean>(false);
  const [isSound, setIsSound] = useState<boolean>(false);
  const [isSpeechActive, setSpeechActive] = useState<boolean>(false);

  useEffect(() => {
    const Recognition =
      (window as any).SpeechRecognition ||
      (window as any).webkitSpeechRecognition;
    if (Recognition) {
      setIsSpeechSupported(true);
      speech.current = new Recognition();
    } else {
      setIsSpeechSupported(false);
    }
  }, []);

  const activateSpeechRecognition = (): void => {
    speech.current.start();
    setSpeechActive(true);
    speech.current.onsoundstart = (): void => setIsSound(true);
    speech.current.onresult = (event: any): void => {
      const speechToText = event.results[0][0].transcript;
      if (speechToText) {
        speech.current.stop();
        getSpeechSearchValue(speechToText);
      }
    };
    speech.current.onend = (): void => {
      setSpeechActive(false);
      setIsSound(false);
    };
  };

  const hideModal = (): void => speech.current.abort();

  return (
    <Form
      role="search"
      onSubmit={handleSubmit}
      action=""
      data-pw="search-input-form"
      active={active}
    >
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <Input
        value={searchValue}
        type="search"
        autoFocus={false}
        required
        aria-label={placeholderValue}
        aria-required="true"
        onChange={handleChange}
        onFocus={handleOnFocus}
        placeholder={!active ? placeholderValue : ''}
      />
      {isSpeechSupported && (
        <MicrophoneIconWrapper
          onClick={activateSpeechRecognition}
          active={active}
        >
          <MicrophoneIcon />
        </MicrophoneIconWrapper>
      )}
      {isSpeechActive && (
        <Modal
          hide={hideModal}
          canClickOutside={true}
          isNarrow={true}
          contentBackground="transparent"
          backgroundOpacity={0.9}
          isBoxShadowed={false}
        >
          <Box p="2" textAlign="center">
            <P my={7} color="white" fontSize="4">
              Speak Title of Track, Release Artist, Project or Label
            </P>
            {isSound ? (
              <IconWrapper>
                <AnimatedRing>&nbsp;</AnimatedRing>
                <ActiveMicrophoneIcon />
              </IconWrapper>
            ) : (
              <InactiveMicrophoneIcon />
            )}
          </Box>
        </Modal>
      )}
    </Form>
  );
};
export default SearchInput;
